export default (function () {
  global.app = global.app || {};
  return global.app;
});